import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={props.width ?? 24} height={props.height ?? 24} viewBox="0 0 24 24" fill="none" {...props}>
        <Path
            d="M3.59998 10.8C4.18225 6.72922 7.68314 3.59998 11.9149 3.59998C15.2658 3.59998 18.1584 5.56204 19.5066 8.39998M19.5074 3.59998V8.39882L14.712 8.39998M20.3946 13.2C19.8123 17.2707 16.3114 20.4 12.0796 20.4C8.72874 20.4 5.83613 18.4379 4.48798 15.6M9.28338 15.6L4.48798 15.6L4.48798 20.4"
            stroke={ds.colorValue.icon.primary}
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
export { SvgComponent as ReuseIcon };
